<template>
  <div class="list-page">
    <crumbs title="用户管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="12">
          <el-input
            v-model="queryCondition.account"
            clearable
            placeholder="账户昵称"
          >
          </el-input>
        </el-col>
        <el-col :span="10">
          <enumerate
            url="/api/user/usercertypeenum"
            v-model="queryCondition.userType"
            placeholder="认证类型"
          />
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <!-- <el-button
        type="warning"
        icon="el-icon-circle-plus"
        >添加用户</el-button
      > -->
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="40"> </el-table-column> -->
        <el-table-column
          prop="account"
          label="账户昵称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="绑定姓名"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="认证企业"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="cerTypeName"
          label="认证类型"
          width="100"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column label="用户状态" width="110" align="center">
          <template slot-scope="scope">
            <span style="padding-right: 10px">{{
              scope.row.status === 1 ? "启用" : "禁用"
            }}</span>
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-color="#409EFF"
              @change="changeUserStatus(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="110" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userCertifiedlist",
  data() {
    return {
      //查询条件
      queryCondition: {
        userType: "",
        account: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    // 修改用户状态
    changeUserStatus(row) {
      const { id, status, userType } = row;
      this.$api("user", "changeUserStatus", {
        id,
        status,
        type: Number.parseInt(userType)
      }).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
      });
    },
    //出来参数
    processParams() {
      let { account, pageIndex, pageSize } = this.queryCondition,
        mixin = {
          userType: ""
        };
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        account,
        pageIndex,
        pageSize,
        ...mixin
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("user", "getCertifiedList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击查看
    handleLook(row) {
      const { id, userType } = row;
      this.redirectByPath(
        `/admin/userManage/userContentInfo/${userType === "2" ? "com" : "per"}`,
        {
          id,
          showAuth: true
        },
        this.queryCondition
      );
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
